export const terms = {
  tattoo: [
    {
      heading: "Rules While in Tattoo Station",
      terms: [
        "No Foods or Drinks allowed in tattoo workstation.",
        "Please sit as still as possible while being tattooed, your final satisfaction is our priority.",
        "Only (1) additional person is allowed in the tattoo station aside from the individual being tattooed.",
        "Please do not leave the workstation during a break or once the tattoo has been completed without it being covered by the artist.",
        "During a break or while being tattooed, DO NOT TOUCH YOUR TATTOO.",
      ],
    },
    {
      heading: "Must Know Before Getting Tattooed",
      terms: [
        "DO NOT overexpose the tattoo to direct sunlight until it’s fully healed.",
        "DO NOT submerge tattoo in water, saltwater, pools, hot tubs, saunas, and steam until it’s fully healed.",
        "AVOID excessive sweating for at least 3 days. Refrain from workouts and engaging in physically demanding jobs / labor.",
        "DO NOT forget to ask for your aftercare products and aftercare instructions before leaving the shop.",
      ],
    },
    {
      heading: "Payment Terms of Service",
      terms: [
        "By completing the following transaction, you acknowledge and agree that all sales are final and non-refundable.",
        "We accept all major credit cards, but there will be a 10% handling fee charged. For example, $100 you will pay a $10 fee.",
        "Cash is Always Better, Save Your Money! There is an ATM across the street at Chase Bank & another at the gas station next door.",
        "Some tattoos are done at a fixed price given by the artist or managers.",
        "Custom full sleeves and large-scale pieces are done at an hourly shop rate of $150-$350 per hour depending on the artist.",
        "Some artist charge between $1,200 - $2,800 for a full day up to 8 hours.",
        "All cover-ups and fix-ups are done at an hourly shop rate of $200-$350 per hour depending on the artist.",
        "If you are paying by the hour, depending on the tattoo, you may be charged for “stencil time”",
      ],
    },
  ],
  smp: [
    {
      heading: "Rules While in Tattoo Station",
      terms: [
        "No Foods or Drinks allowed in tattoo workstation.",
        "Please sit as still as possible while being tattooed, your final satisfaction is our priority.",
        "Only (1) additional person is allowed in the tattoo station aside from the individual being tattooed.",
        "Please do not leave the workstation during a break or once the tattoo has been completed without it being covered by the artist.",
        "During a break or while being tattooed, DO NOT TOUCH YOUR TATTOO.",
      ],
    },
    {
      heading: "Must Know Before Getting Tattooed",
      terms: [
        "DO NOT overexpose the tattoo to direct sunlight until it’s fully healed.",
        "DO NOT submerge tattoo in water, saltwater, pools, hot tubs, saunas, and steam until it’s fully healed.",
        "AVOID excessive sweating for at least 3 days. Refrain from workouts and engaging in physically demanding jobs / labor.",
        "DO NOT forget to ask for your aftercare products and aftercare instructions before leaving the shop.",
      ],
    },
    {
      heading: "Payment Terms of Service",
      terms: [
        "By completing the following transaction, you acknowledge and agree that all sales are final and non-refundable.",
        "We accept all major credit cards, but there will be a 10% handling fee charged. For example, $100 you will pay a $10 fee.",
        "Cash is Always Better, Save Your Money! There is an ATM across the street at Chase Bank & another at the gas station next door.",
        "Some tattoos are done at a fixed price given by the artist or managers.",
        "Custom full sleeves and large-scale pieces are done at an hourly shop rate of $150-$350 per hour depending on the artist.",
        "Some artist charge between $1,200 - $2,800 for a full day up to 8 hours.",
        "All cover-ups and fix-ups are done at an hourly shop rate of $200-$350 per hour depending on the artist.",
        "If you are paying by the hour, depending on the tattoo, you may be charged for “stencil time”",
      ],
    },
  ],
  piercing: [
    {
      heading: "Rules While in Piercing Room",
      terms: [
        "No Foods or Drinks allowed in piercing room.",
        "Please sit as still as possible while being pierced, your final satisfaction is our priority.",
        "Only the Individual being pierced is allowed in the piercing room.",
      ],
    },
    {
      heading: "Must Know Before Getting Pierced",
      terms: [
        "DO NOT submerge piercing in water, saltwater, pools, hot tubs, saunas, and steam until it’s fully healed.",
        "AVOID excessive sweating for at least 3 days. Refrain from workouts and engaging in physically demanding jobs / labor.",
        "DO NOT forget to ask for your aftercare products and aftercare instructions before leaving the shop.",
      ],
    },
    {
      heading: "Payment Terms of Service",
      terms: [
        "By completing the following transaction, you acknowledge and agree that all sales are final and non-refundable.",
        "We accept all major credit cards, but there will be a 10% handling fee charged. For example, $100 you will pay a $10 fee.",
        "Cash is Always Better, Save Your Money! There is an ATM across the street at Chase Bank & the gas station next door.",
      ],
    },
  ],
  "permanent-makeup": [
    {
      heading: "Rules While in Tattoo Station",
      terms: [
        "No Foods or Drinks allowed in tattoo workstation.",
        "Please sit as still as possible while being tattooed, your final satisfaction is our priority.",
        "Only (1) additional person is allowed in tattoo station aside from the individual being tattooed.",
        "Please do not leave the workstation during a break or once the tattoo has been completed without it being covered by the artist.",
        "During a break or while being tattooed, DO NOT TOUCH YOUR TATTOO.",
      ],
    },
    {
      heading: "Must Know Before Getting Tattooed",
      terms: [
        "DO NOT overexpose the tattoo to direct sunlight until it’s fully healed.",
        "DO NOT submerge tattoo in water, saltwater, pools, hot tubs, saunas, and steam until it’s fully healed.",
        "AVOID excessive sweating for at least 3 days. Refrain from workouts and engaging in physically demanding jobs / labor.",
        "DO NOT forget to ask for your aftercare products and aftercare instructions before leaving the shop.",
      ],
    },
    {
      heading: "Payment Terms of Service",
      terms: [
        "By completing the following transaction, you acknowledge and agree that all sales are final and non-refundable.",
        "We accept all major credit cards, but there will be a 10% handling fee charged. For example, $100 you will pay a $10 fee.",
        "Cash is Always Better, Save Your Money! There is an ATM across the street at Chase Bank & the gas station next door.",
      ],
    },
  ],
  removal: [
    {
      heading: "Rules While in Tattoo Station",
      terms: [
        "No Foods or Drinks allowed in the tattoo workstation.",
        "Please sit as still as possible during the removal process, your final satisfaction is our priority.",
        "Only (1) additional person is allowed in the tattoo station aside from the individual being tattooed.",
        "Please do not leave the workstation during a break or once the tattoo removal has been completed without it being covered by the artist.",
        "During a break or during the procedure, DO NOT TOUCH THE AREA OF THE REMOVAL.",
      ],
    },
    {
      heading: "Must Know Before Getting Tattoo Removal",
      terms: [
        "DO NOT overexpose the site of the tattoo removal procedure to direct sunlight until it’s fully healed.",
        "DO NOT submerge the site of the tattoo removal procedure in water, saltwater, pools, hot tubs, saunas, and steam until it’s fully healed.",
        "Keep the treated area clean and dry any moisture or wetness to the treated area can cause the area to become infected and/or cause the scab to come off too soon which may lead to less-than-desirable results and scarring. This includes ANY physical activity that may cause exertion and/or sweating. Refrain from workouts and engaging in physically demanding jobs/labor for at least 7-10 days or until the scab has fallen off naturally. Medical-grade shower patches are available for purchase.",
        "If the treated area is below the elbow or knee, elevate 10 minutes every 2 hours for three days.",
        "Nothing else is allowed in the treated area, such as but not limited to makeup or ointment until healing has taken place and the expected scab has come off without interference.",
        "After the scab exfoliates naturally, the skin may appear pink for up to one year longer following the removal process.",
        "Don’t forget to ask for your aftercare products and aftercare instructions before leaving the shop.",
      ],
    },
    {
      heading: "Payment Terms of Service",
      terms: [
        "By completing the following transaction, you acknowledge and agree that all sales are final and non-refundable.",
        "We accept all major credit cards, but there will be a 10% handling fee charged. For example, $100 you will pay a $10 fee.",
        "Cash is Always Better, Save Your Money! There is an ATM across the street at Chase Bank & the gas station next door.",
      ],
    },
  ],
  "tooth-gems": [
    {
      heading: "Rules for During the Procedure",
      terms: [
        "No Foods or Drinks allowed in the workstation.",
        "Please sit as still as possible during the procedure, your final satisfaction is our priority.",
        "Only the Individual getting a tooth gem is allowed in the workstation.",
        "DO NOT forget to ask for your aftercare instructions before leaving the shop.",
      ],
    },
    {
      heading: "Must Know Before Getting Tooth Gems",
      subHeading:
        "Conditions that could prevent my tooth gem from staying on:the following conditions could potentially have trouble with their tooth gem lasting as long as others.",
      terms: [
        "Those who have had oral surgery or extractions within the last 30 days",
        "Those who have not had a dental cleaning within the last 6 months",
        "Those with periodontal issues",
        "Those with excessive plaque and tartar",
        "Those with existing dental issues, tooth decay, cavities, periodontal disease, gingivitis, etc.",
        "Those who eat foods with a lot of acidity and/or sugary substances in excess",
        "Those who smoke in excess",
        "Those who do not follow the aftercare instructions",
      ],
      bottomHeading:
        "You should wait 60 minutes before consuming anything to ensure your Tooth Gem sets properly",
    },
    {
      heading: "Payment Terms of Service",
      terms: [
        "By completing the following transaction, you acknowledge and agree that all sales are final and non-refundable.",
        "We accept all major credit cards, but there will be a 10% handling fee charged. For example, $100 you will pay a $10 fee.",
        "Cash is Always Better, Save Your Money! There is an ATM across the street at Chase Bank & the gas station next door.",
      ],
    },
  ],
};
